export default __webpack_public_path__ + "static/media/playlists.ca3ccef0.svg";